<template>
  <div class="color-palette">
    <div v-if="colorPaletteIcon" class="color-palette__icon" v-html="icons.colorPaletteIcons[colorPaletteIcon]"></div>
    <fs-pill-season
      v-else-if="colorPaletteSeasonId"
      class="color-palette__season"
      :season-id="colorPaletteSeasonId"
      size="small"
    />
    <fs-tooltip v-else :text="palette.name" class="color-palette__name">{{ palette.name }}</fs-tooltip>
  </div>
</template>

<script>
import colorPaletteIcons from '@lib/icons-imports/color-palettes';
import FsPillSeason from '@components/pills/fs-pill-season.vue';
import FsTooltip from '@components/poppers/fs-tooltip.vue';

export default {
  name: 'color-palette-snippet',
  props: {
    paletteId: { type: Number },
  },

  components: { FsPillSeason, FsTooltip },

  data() {
    return {
      icons: {
        colorPaletteIcons,
      },
    };
  },

  computed: {
    palette() {
      return this.$store.colors.palettes.find((p) => p.id === this.paletteId);
    },

    colorPaletteIcon() {
      return this.palette?.icon;
    },

    colorPaletteSeasonId() {
      return this.palette?.seasonId;
    },
  },
};
</script>

<style scoped lang="scss">
@import '@styles/variables';

.color-palette {
  height: 1.2rem;
  display: flex;
  align-items: flex-start;

  &__icon {
    flex: 0 0 auto;
    color: $c-dark;
    opacity: 1;
  }

  &__season {
  }

  &__name {
    font-size: 1rem;
    line-height: 1.2rem;
    color: rgba($c-dark, 0.5);
    text-transform: uppercase;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
}
</style>
